<ion-row *ngIf="data?.percentages?.length > 0">
  <div
    *ngFor="let item of data?.percentages; let i = index"
    class="row-list-text"
  >
    <div *ngIf="item?.percentage" [attr.data-cy]="item?.dataCy">
      <div *appShowSplit="[item?.displayFlag]">
        <h1 [attr.data-cy]="item?.dataCy + '-percentage'">
          {{ item?.percentage }}%
        </h1>
        <div [attr.data-cy]="item?.dataCy + '-title'">{{ item?.title }}</div>
      </div>
      <div
        *ngIf="data?.lineDivider && i < data?.percentages.length - 1"
        class="line-divider"
      ></div>
    </div>
  </div>
</ion-row>
